import { Component, HostListener, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Observable } from 'rxjs';
import { SessionExpiryService } from '../core/auth/session-expiry.service';
import { NavigationService } from '../core/services/navigation.service';

@Component({
    selector: 'dmp-layout',
    templateUrl: './layout.component.html',
    styleUrls: ['./layout.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class LayoutComponent implements OnInit, OnDestroy {
  sidebarOpen$!: Observable<boolean>;
  sidebarCollapsed$!: Observable<boolean>;

  constructor(
    private navService: NavigationService,
    private sessionExpiry: SessionExpiryService,
  ) {}

  ngOnInit(): void {
    this.sidebarOpen$ = this.navService.sidebarOpen$;
    this.sidebarCollapsed$ = this.navService.sidebarCollapsed$;
    this.sessionExpiry.watchProtectedSession();
  }

  ngOnDestroy(): void {
    this.sessionExpiry.stop();
  }

  closeSidebar(): void {
    this.navService.closeSidebar();
  }

  @HostListener('document:keydown', ['$event'])
  onDocumentKeydown(event: KeyboardEvent): void {
    if ((event.ctrlKey || event.metaKey) && event.key.toLowerCase() === 'b') {
      event.preventDefault();
      this.navService.toggleCollapse();
    }
  }
}
